import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LeadsDataServiceProvider {
	job2Edit: BehaviorSubject<any> = new BehaviorSubject(false);
	forceJobUpdate: BehaviorSubject<any> = new BehaviorSubject(false);

	constructor(public http: HttpClient) {}

	get leadObservable() {
		return this.job2Edit.asObservable();
	}

	get shouldLeadBeUpdatedObservable() {
		return this.forceJobUpdate.asObservable();
	}

	emitLead(job) {
		return this.job2Edit.next(JSON.parse(JSON.stringify(job)));
	}

	emitForceLeadUpdateEvent(value) {
		this.forceJobUpdate.next(value);
	}

	getLeadInfo(id, showTaskId = '') {
		const url = `/api/user/lead/${id}`;
		let params = new HttpParams();
		params = params.append('showTaskId', showTaskId);
		return this.http.get(url, { params });
	}

	editLead(lead) {
		const url = '/api/user/lead/create';
		return this.http.post(url, lead);
	}

	getActiveJobs() {
		const url = '/protected/rest/jobs/active';
		return this.http.get(url);
	}

	getLeadsOnPageV2(pageRequest, perPageChanged) {
		const url = '/api/user/lead/v2';

		const {
			perPage,
			page,
			pageOrder: { predicate, reverse },
			search,
			searchToken,
			filter
		} = pageRequest;

		const params = {
			filter,
			search,
			paging: {
				pageNumber: page,
				pageSize: perPage,
				searchToken
			},
			sortCriteria: {
				fieldName: predicate,
				sortAscending: reverse
			}
		};

		if (perPageChanged) {
			delete params.paging.searchToken;
		}

		return this.http.post(url, params);
	}

	getLeadsOnPage(pageRequest, perPageChanged) {
		const url = '/api/user/lead/v2';

		if (perPageChanged) {
			delete pageRequest.paging.searchToken;
		}

		return this.http.post(url, pageRequest);
	}

	changeTaskState(leadIdId, task) {
		const url = `/protected/rest/jobs/${leadIdId}/tasks/${task.id}`;
		const body = JSON.stringify(task.completed);
		const headers = new HttpHeaders().set(
			'Content-Type',
			'application/json;charset=UTF-8'
		);

		return this.http.post(url, body, { headers });
	}

	deleteLead(leadId) {
		const url = `/api/user/lead/${leadId}`;
		return this.http.delete(url);
	}

	archiveLead(leadId: number): Observable<any> {
		const url = `/api/user/lead/archive/${leadId}`;
		return this.http.post(url, {});
	}

	unarchiveLead(leadId: number): Observable<any> {
		const url = `/api/user/lead/unarchive/${leadId}`;
		return this.http.post(url, {});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/lead/leads.data.service.ts